
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';

interface MaturityModelStatusProps {
  isMaturityModel: boolean;
}

export function MaturityModelStatus({
  isMaturityModel
}: MaturityModelStatusProps) {
  return (
    <div className="flex items-center justify-between space-x-2 border p-4 rounded-md">
      <div className="space-y-1">
        <Label className="flex flex-col space-y-1">
          <div className="flex items-center gap-2">
            <span>Maturity Model Status</span>
            {isMaturityModel && (
              <Badge variant="outline" className="bg-purple-100 text-purple-800 hover:bg-purple-100 border-none rounded-full px-3">
                Maturity Model
              </Badge>
            )}
          </div>
          <span className="font-normal text-sm text-muted-foreground">
            {isMaturityModel 
              ? 'This is a maturity model assessment (non-editable after creation)' 
              : 'This is a standard assessment (non-editable after creation)'}
          </span>
        </Label>
      </div>
      <Switch
        id="is-maturity-model"
        checked={isMaturityModel}
        disabled={true} // Always disabled in edit mode
      />
    </div>
  );
}
